import { render, staticRenderFns } from "./ProjectStatisticWorkloadConfigList.vue?vue&type=template&id=789ff697&scoped=true"
import script from "./ProjectStatisticWorkloadConfigList.vue?vue&type=script&lang=js"
export * from "./ProjectStatisticWorkloadConfigList.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatisticWorkloadConfigList.vue?vue&type=style&index=0&id=789ff697&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789ff697",
  null
  
)

export default component.exports